export const WelcomeStepActions = {
  transclude: true,

  bindings: {
    isLoading: '<',
    onCancel: '&',
  },

  template: `
    <div class="welcome-step-actions">
      <button-primary
        class="mr-1"
        ng-click="$ctrl.onCancel()"
        is-inverse="true">
        Cancel
      </button-primary>
      <button-primary
        ng-type="submit"
        ng-disabled="$ctrl.isLoading">
        <spinner is-loading="$ctrl.isLoading">
          <ng-transclude>Done</ng-transclude>
        </spinner>
      </button-primary>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/WelcomeSteps/WelcomeStepActions.js